//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n from "@/utils/i18n";
export default {
  name: "gutter-editor",
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  methods: {
    spanChanged: function spanChanged(curGrid) {
      var spanSum = 0;
      curGrid.cols.forEach(function (colItem) {
        spanSum += colItem.options.span;
      });
      if (spanSum > 24) {
        //this.$message.info('列栅格之和超出24')
        console.log('列栅格之和超出24');
        //TODO: 语言字符串资源化
      }
      this.designer.saveCurrentHistoryStep();
    },
    deleteCol: function deleteCol(curGrid, colIdx) {
      this.designer.deleteColOfGrid(curGrid, colIdx);
      this.designer.emitHistoryChange();
    },
    addNewCol: function addNewCol(curGrid) {
      this.designer.addNewColOfGrid(curGrid);
      this.designer.emitHistoryChange();
    }
  }
};